import { render, staticRenderFns } from "./newAss.vue?vue&type=template&id=0c3bf805&scoped=true"
import script from "./newAss.vue?vue&type=script&lang=js"
export * from "./newAss.vue?vue&type=script&lang=js"
import style0 from "./newAss.vue?vue&type=style&index=0&id=0c3bf805&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3bf805",
  null
  
)

export default component.exports